import { createStore } from 'vuex';
import settings from './modules/settings';
import user from './modules/user';
import loan from './modules/loan';
import theme from './modules/theme';

export default createStore({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        settings,
        user,
        loan,
        theme,
    },
});
